import React from 'react'

import Relazsizes from 'relazsizes'

import PropTypes from 'prop-types'
import config from 'config'

const { assets_url: assetsUrl } = config

const BannerPlaceholder = ({ number, onClick }) => {
  const contents = [
    {
      url: '/directory?study_field=Manajemen',
      image: `${assetsUrl}/assets/img/placeholders/banner-manajemen.png`,
    },
    {
      url: '/directory?location=DKI%20Jakarta',
      image: `${assetsUrl}/assets/img/placeholders/banner-jakarta.png`,
    },
  ]

  return (
    <a href={contents[number].url} onClick={onClick}>
      <div className="small-banner">
        <Relazsizes src={contents[number].image} className="campus-logo-footer" />
      </div>
    </a>
  )
}

BannerPlaceholder.propTypes = {
  number: PropTypes.number.isRequired,
  onClick: PropTypes.func,
}

export default BannerPlaceholder
